<div class="feedback d-flex align-items-center justify-content-around h-100">
    <a
        href="https://www.ark.org/feedback/index.php/home/feedback?service_id=a03G000001fbqjR&score=3"
        target="_blank"
        ><img
            height="40px"
            width="40px"
            src="https://static.ark.org/feedback/smiley.png"
            alt="Great!"
        /></a
    >
    <a
        href="https://www.ark.org/feedback/index.php/home/feedback?service_id=a03G000001fbqjR&score=2"
        target="_blank"
        ><img
            height="40px"
            width="40px"
            src="https://static.ark.org/feedback/indifferent.png"
            alt="Ok"
        /></a
    >
    <a
        href="https://www.ark.org/feedback/index.php/home/feedback?service_id=a03G000001fbqjR&score=1"
        target="_blank"
        ><img
            height="40px"
            width="40px"
            src="https://static.ark.org/feedback/frown.png"
            alt="Not Good"
        /></a
    >
</div>
